 
import http from "@/http/service"
 
export default function Dashboard(){

    return http.get(`/admin/dashboard`)

}